import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: routes.DASHBOARD,
    name: 'DASHBOARD',
    component: () => import('./DashboardPage.vue'),
    meta: { requiresAuth: true },
  },
]
